'use strict'

if (!module.hot || process.env.NODE_ENV === 'production') {
  module.exports = require('./dist/react-hot-loader.production.min.js');
} else {
  module.exports = require('./dist/react-hot-loader.development.js');
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-hot-loader/index.js
// module id = ./node_modules/react-hot-loader/index.js
// module chunks = 0